import { peersRelationIdSelector, selectedRelationIdSelector } from 'selectors/peergroupSelectors'
import { DEFAULT_TIMEFRAMES } from 'constants/datetime'
import { WithPlacement } from 'interfaces/insights'
import { getAnchorPage, isAccountPage, isMoneyflowPage, isTimeframedPage } from 'helpers/pageHelpers'
import * as isNumber from 'lodash/isNumber'
import { getInsightsActionCreator } from 'actions/insightsActions'
import { CategoryId } from 'interfaces/meta'
import { WatchingGuard } from 'interfaces/guards'
import { InsightsPageType } from 'interfaces/pages'
import { Timeframe } from 'interfaces/chart'
import { createGuardOrderError } from 'helpers/errorHelpers'
import { createIsPlacementUpToDateSelector } from 'selectors/insightsSelectors'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

type InsightsWatch = {
  timeframe: Timeframe
  peersRelationId: number | null
  othersRelationId: number | null
  page: Exclude<InsightsPageType, 'transactions'>
  category?: CategoryId
}

export const createInsightsGuard = (): WatchingGuard<WithPlacement, InsightsWatch> => {
  const checker = createIsPlacementUpToDateSelector()

  return {
    name: 'Insights',
    checker,
    watcher: (state, { placement }) => {
      const peersRelationId = peersRelationIdSelector(state)
      const othersRelationId = selectedRelationIdSelector(state)
      const withComparison = withComparisonSelector(state)

      const page = getAnchorPage(placement) as Exclude<InsightsPageType, 'transactions'>
      const category = isAccountPage(page) || isMoneyflowPage(page)
        ? state.app[page].categories.selectedId
        : undefined

      const timeframe = isTimeframedPage(page)
        ? state.app[page].timeframe
        : DEFAULT_TIMEFRAMES[page]

      return {
        page,
        timeframe,
        peersRelationId,
        othersRelationId,
        category,
        withComparison,
      }
    },
    loader: (dispatch, { page, timeframe, peersRelationId, othersRelationId, category }) => {
      if (!isNumber(peersRelationId) || !isNumber(othersRelationId)) {
        throw createGuardOrderError('insightsGuard', 'peergroupsGuard')
      }

      if (isAccountPage(page)) {
        dispatch(getInsightsActionCreator(page, timeframe, peersRelationId, othersRelationId, category as CategoryId))
      } else if (isMoneyflowPage(page)) {
        // this is a sacrifice to a TS god
        dispatch(getInsightsActionCreator(page, timeframe, peersRelationId, othersRelationId, category as CategoryId))
      } else {
        dispatch(getInsightsActionCreator(page, timeframe, peersRelationId, othersRelationId))
      }
    },
  }
}
